import { render, staticRenderFns } from "./SearchUsersComponent.vue?vue&type=template&id=08c3fcaf&scoped=true"
import script from "./SearchUsersComponent.vue?vue&type=script&lang=js"
export * from "./SearchUsersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c3fcaf",
  null
  
)

export default component.exports